export default {
  glow: {
    active: 'Aktiv',
    blankText: '(tom)',
    clearAll: 'Tøm alle',
    cancel: 'Avbryt',
    close: 'Lukk',
    copied: 'Kopiert',
    confirm: 'Bekreft',
    copyFailed: 'Kopiering mislyktes',
    copyValue: 'Kopier {{value}}',
    deselectAll: 'Opphev alle',
    dismiss: 'Lukk',
    event: {
      serviceUpgrade: {
        title: 'Tjensteoppgradering',
        curbside: 'Levering til fortauskanten',
        indoor: 'Innbæring',
        deliveryDate: 'Leveringsdato'
      },
      shorterTimeWindow: {
        title: 'Kortere tidsvindu'
      }
    },
    emptyStates: {
      notFoundTitle: 'Ingen resultater',
      notFoundDescription: 'Vi fant ingen resultater. Juster søkefilteret ditt og prøv igjen.',
      initialTitle: 'Ingen informasjon ennå',
      successTitle: 'Bra jobbet!'
    },
    filter: 'Filter',
    filterOverlay: {
      filter: 'Filter',
      activeFilterCount: '{{count}} aktivt filter',
      activeFilterCount_other: '{{count}} aktive filtre',
      clearFilter: 'Fjern filter'
    },
    from: 'Fra',
    goToPage: 'Gå til side',
    group: 'Gruppe',
    invalidDateFormat: 'Ugyldig datoformat',
    openCalendar: 'Vis kalender',
    loading: 'Laster',
    no: 'Nei',
    none: 'Intet valg',
    notActivated: 'Ikke aktivert',
    of: 'av',
    orderOfTable: 'Rekkefølgen på kolonneoverskriftene',
    orderOfTableDescription: 'Velg den foretrukne rekkefølgen for kolonneoverskriftene ved å dra og slippe.',
    fixedTableHeadersDescription: 'Følgende kolonneoverskrifter er faste og kan ikke fjernes eller flyttes.',
    page: 'side',
    search: 'Søk',
    selectAll: 'Velg alle',
    selectAllCount: 'Velg alle ({{count}})',
    selectAllOnPage: 'Velg alle på siden ({{count}})',
    settings: 'Innstillinger',
    to: 'Til',
    yes: 'Ja',
    accordionMessage: {
      error: '{{count}} feilmeldinger',
      warning: '{{count}} advarsler',
      info: '{{count}} informasjonsmeldinger',
      general: '{{count}} meldinger'
    },
    invalidRegistrationNumber: 'Skriv inn et gyldig registreringsnummer som bare inneholder bokstaver og tall',
    invalidRegistrationNumber_SE: 'Ugyldig format. Forventet: ABC123 eller ABC12D',
    invalidRegistrationNumber_DK: 'Ugyldig format. Forventet: AB12345',
    invalidRegistrationNumber_NO: 'Ugyldig format. Forventet: AB1234 eller AB12345'
  }
}
